import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { getSectionList, getUserInfo, saveUserInfo, uploadFile } from 'Root/http';
import { isSupervisorUser } from 'Auth/redux/auth.redux';
import { routeGenerator } from 'routes';

import UserInfo from './UserInfo/UserInfo';
import Roles from './Roles/Roles';
import GrantTree from './GrantTree/GrantTree';

import s from './UserPage.pcss';
import Loader from '../../../../shared/components/Loader/Loader';


@withRouter
@connect(
  state => ({
    isSupervisor: isSupervisorUser(state),
  }),
)
class UserPage extends Component {
  static propTypes = {
    isSupervisor: PropTypes.bool.isRequired,
    match: PropTypes.shape().isRequired,
    history: PropTypes.shape().isRequired,
  };

  state = {
    treeData: [],
    roleList: [],
    userData: {},
    loading: false,
  };

  componentDidMount() {
    const userId = this.props.match.params.userId;
    this.setState({ loading: true }, () => {
      this.loadData(userId);
    });
  }

  loadData = async (userId) => {
    const userData = await getUserInfo(userId);
    const treeData = await getSectionList(this.props.isSupervisor);
    this.setState({ userData, roleList: userData.roleArray || [], treeData, loading: false });
  };

  editUser = data => saveUserInfo(data).then(userData => this.setState({ userData }));

  updateRoles = (roleList) => {
    this.setState({ roleList });
  };

  onRoleSelect = roleId =>
    this.props.history.push(routeGenerator.userRoleLink(this.props.match.params.userId, roleId));

  photoChange = file =>
    uploadFile(file)
      .then((photo) => {
        const id = this.props.match.params.userId;
        const data = { photo, id };
        return saveUserInfo(data).then((userData) => {
          this.setState({ userData });
          return Promise.resolve();
        });
      });

  render() {
    const { roleList, userData, treeData, loading } = this.state;
    const { userId, roleId } = this.props.match.params;
    const role = roleList.find(r => r.id === roleId) || {};
    const grantsDisabled = this.props.isSupervisor && !!role.forbiddenForSupervisorAdmin;
    if (loading) {
      return (
        <Loader />
      );
    }
    return (
      <div className={s.container}>
        <div className={s.infoContainer}>
          <UserInfo data={userData} onEdit={this.editUser} onPhotoChange={this.photoChange} />
        </div>
        <div className={s.intersectionContainer}>
          <Roles
            roles={roleList}
            updateRoles={this.updateRoles}
            onRoleSelect={this.onRoleSelect}
          />
          <GrantTree
            treeData={treeData}
            userId={userId}
            roleId={roleId}
            disabled={grantsDisabled}
          />
        </div>
      </div>
    );
  }
}

export default UserPage;



// WEBPACK FOOTER //
// ./src/Root/pages/Users/UserPage/UserPage.js